<template>
  <div class="stream-item border border-dark rounded">
    <div class="card bg-dark position-relative">
      <div class="card-body py-2  stream-header">
        <p class="card-text d-flex justify-content-between text-light mb-0">
          <template v-if="Object.keys(stream).length > 0">
            <template v-if="stream.org">
              <span>
                <span class="d-inline-block text-truncate">
                  {{ stream.org.TYPE_OBJECT }}
                  <template v-if="stream.org.CODE_PPE_EGE && stream.USAGE === '1'">
                    {{ stream.org.CODE_PPE_EGE }} <small class="badge badge-pill badge-primary">ЕГЭ</small>
                  </template>
                  <template v-if="stream.org.CODE_PPE_OGE && stream.USAGE === '0'">
                    {{ stream.org.CODE_PPE_OGE }} <small class="badge badge-pill badge-info">ОГЭ</small>
                  </template>
                </span>
                &nbsp;<span class="text-muted d-inline-block text-truncate">{{ address }}</span>
                <span v-if="control" class="text-muted d-inline-block text-truncate ml-3"><b>{{ stream.IP_ADDRESS }}</b></span>
              </span>
            </template>
          </template>
          <b-button size="sm" :variant="show ? 'info' : 'dark'" :disabled="Object.keys(stream).length === 0" class="ml-auto" @click.prevent="show = !show" title="Действия">
            <font-awesome-icon :icon="['fas', 'ellipsis-v']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" variant="dark" v-show="Object.keys(stream).length !== 0" v-if="change" @click.prevent="clearStream" title="Закрыть">
            <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
          </b-button>
        </p>
      </div>
      <div class="card-body position-relative p-0">
        <div class="row">
          <div :class="{ 'col-12' : !show, 'col-9' : show }">
            <v-clappr :el="htmlId" :source="stream.HLS_LINK" :options="options" v-if="stream.STREAM_STATUS === 'started'" @init="oninit" @error="onerror" />
            <div v-else class="video-placeholder d-flex align-items-center justify-content-around">
              <div class="text-light text-center">
                <b v-if="Object.keys(stream).length > 0">Трансляция отключена<template v-if="!control">, <br>свяжитесь с администратором</template></b>
                <div v-else>
                  <b-button variant="primary" class="shadow-lg" @click.prevent="selectPak" v-if="change"><font-awesome-icon :icon="['fas', 'video']"></font-awesome-icon> Выбрать камеру</b-button>
                </div>
              </div>
            </div>
          </div>
          <transition name="slide-fade" mode="out-in">
            <div class="stream-panel p-2 col-3" v-show="show">
              <div class="h-100 d-flex justify-content-center align-items-center">
                <div>
                  <div></div>
                  <template v-if="control">
                    <b-button variant="primary" size="sm" class="btn-block" @click.prevent="startBroadcast" v-if="stream.STREAM_STATUS === 'stopped'">
                      Начать трансляцию
                    </b-button>
                    <b-button variant="primary" size="sm" class="btn-block" @click.prevent="stopBroadcast" v-if="stream.STREAM_STATUS === 'started'">
                      Остановить трансляцию
                    </b-button>
                  </template>

                  <b-button variant="info" size="sm" class="btn-block" @click.prevent="selectPak" v-if="change">Выбрать другую
                    камеру
                  </b-button>
                  <b-button variant="danger" size="sm" class="btn-block" v-if="violation && stream.STREAM_STATUS === 'started'" @click.prevent="$emit('violation', index)">Нарушение!</b-button>
                  <br>
                  <template v-if="isStarting || isStopping">
                    <div class="text-center"><span
                      class="online text-warning"
                      v-text="isStopping ? 'Завершается...' : 'Запускается...' "></span></div>
                  </template>
                  <template v-else>
                    <div class="text-center" v-if="stream.STREAM_STATUS"><span
                      :class="{ 'online' : true, 'text-success' : stream.STREAM_STATUS === 'started', 'text-danger' : stream.STREAM_STATUS === 'stopped' }"
                      v-text="stream.STREAM_STATUS === 'started' ? 'Онлайн' : 'Оффлайн' "></span></div>
                  </template>

                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VClappr from 'v-clappr'
  import { Browser } from 'clappr'
  import { apiQuery } from "../api"
  import Vuex from 'vuex'

/* eslint-disable no-extra-boolean-cast */
  export default {
    name: "Stream",
    components: { VClappr },
    props: {
      htmlId: String,
      change: Boolean,
      violation: Boolean,
      control: Boolean,
      index: {
        type: Number,
        default: null
      },
      stream: {
        type: Object,
        default: () => { return {} }
      }
    },
    data() {
      return {
        loading: true,
        show: false,
        isStopping: false,
        isStarting: false,
        player: null,
        na: false,
        options: {
          width: 'auto',
          height: 38+'vh',
          poster: '',
          mute: true,
          autoplay: true,
          loop: false,
          disable_context_menu: false,
          disable_keyboard_shortcuts: false,
          mediacontrol: {},
          ga: {
            account: '',
            tracker_name: '',
          },
          watermark: {
            image: '',
            url: '',
            position: 'top-right',
          },
          plugins: [],
          chromeless: false,
          allow_user_interaction: false,
          i18n: {
            en: {
              live: 'прямая трансляция',
              back_to_live: 'вернуться к трансляции',
              disabled: 'выключено',
              playback_not_supported: 'Похоже, ваш браузер не поддерживает трансляцию',
              default_error_title: 'Не удалось воспроизвести видео',
              default_error_message: 'Проблема при загрузке видео. Повтор....',
            },
          },
          mime_type: '',
          actual_live_time: '',
          preload: '',
          playback: {
            preload: 'metadata',
            controls: false,
            playInline: true, // allows inline playback when running on iOS UIWebview
            crossOrigin: '',
            recycleVideo: Browser.isMobile, // Recycle <video> element only for mobile. (default is true)
            triggerFatalErrorOnResourceDenied: true, // Triggers playback fatal error if resource is denied. (default is false)
            externalTracks: [],
            hlsUseNextLevel: false,
            hlsjsConfig: {},
          },
          cc: {
            title: '',
            ariaLabel: '',
            labelCallback: () => {},
          },
        },
      }
    },
    computed: {
      address() {
        let string = this.stream.org.ADDRESS + (this.stream.room && Object.prototype.hasOwnProperty.call(this.stream.room,'CLASSROOM') && this.stream.room.CLASSROOM.length > 0 ? ', ауд. ' + this.stream.room.CLASSROOM : '') +
          (this.stream.room && Object.prototype.hasOwnProperty.call(this.stream.room,'CODE_CLASSROOM') && this.stream.room.CODE_CLASSROOM.length > 0 ? ' (код ' + this.stream.room.CODE_CLASSROOM + ')' : '')
        return string.length > 50 ? '...' + string.substring(string.length-50) : string
      }
    },
    watch: {
      stream: {
        handler() {
          this.attempts = 0
          if (Object.prototype.hasOwnProperty.call(this.stream,'HLS_LINK')) {
            if (process.env.NODE_ENV === 'development')
              this.stream.HLS_LINK = this.stream.HLS_LINK.replace('https://smotrigia.pskovedu.ru', '')
            if (this.player) {
              this.player.configure({
                source: this.stream.HLS_LINK,
              });
            }
          }
          else {
            this.show = true
          }
          if (Object.keys(this.stream).length === 0)
            this.show = false
        },
        deep: true
      }
    },
    mounted() {
      if (Object.prototype.hasOwnProperty.call(this.stream,'HLS_LINK') && process.env.NODE_ENV === 'development')
        this.stream.HLS_LINK = this.stream.HLS_LINK.replace('http://smotrigia.pskovedu.ru', '')
    },
    methods: {
      ...Vuex.mapMutations([
          'toggleSearch',
          'setIndex',
          'setStream'
      ]),

      oninit(clappr) {
        this.player = clappr;
      },

      onerror(error) {
        if (Object.prototype.hasOwnProperty.call(error.raw, 'response') && Object.prototype.hasOwnProperty.call(error.raw.response, 'code') && error.raw.response.code === 404) {
          setTimeout(() => {
            const s = this.player.options.source;
            const o = this.player.options;
            o.source = s;
            this.player.configure(o);
          }, 5000)
        }
        if (this.isStopping)
          this.updateStream()
      },

      selectPak() {
        this.setIndex(this.index)
        this.toggleSearch()
      },

      startBroadcast() {
        let ctx = {};
        this.isStarting = true
        ctx[window.x2.tables.schools] = this.stream.org.SYS_GUID
        ctx[(this.stream.USAGE === '0' ? window.x2.tables.rooms : window.x2.tables.egerooms)] = this.stream.room.SYS_GUID
        return apiQuery('private', 'action-execute', {
          action: '7EC3EAD6A3D14E47B4C795F5B6E3206C',
          recordIds: [this.stream.SYS_GUID],
          context: { state: ctx }
        }, false).then(() => {
          setTimeout(() => { this.updateStream(); }, 10000)
        })
      },

      stopBroadcast() {
        let ctx = {};
        this.isStopping = true
        ctx[window.x2.tables.schools] = this.stream.org.SYS_GUID
        ctx[(this.stream.USAGE === '0' ? window.x2.tables.rooms : window.x2.tables.egerooms)] = this.stream.room.SYS_GUID
        return apiQuery('private', 'action-execute', {
          action: 'B305FA8726E94F19BA48B19084C14B74',
          recordIds: [this.stream.SYS_GUID],
          context: { state: ctx }
        }, false)
      },

      updateStream() {
        let ctx = {};
        ctx[window.x2.tables.schools] = this.stream.org.SYS_GUID
        ctx[(this.stream.USAGE === '0' ? window.x2.tables.rooms : window.x2.tables.egerooms)] = this.stream.room.SYS_GUID
        return apiQuery('private', 'data-get-records', {
          table: (this.stream.USAGE === '0' ? window.x2.tables.pak : window.x2.tables.pakege),
          context: { state: ctx }
        }, false).then(response => {
          let curr = response.rows.find(item => item.SYS_GUID === this.stream.SYS_GUID)
          let stream = this.stream
          stream.HLS_LINK = null
          let pak = Object.assign(stream, curr)
          this.setIndex(this.index)
          this.setStream(pak)
          this.isStarting = false
          this.isStopping = false
        })
      },

      clearStream() {
        this.$emit('clear', this.index)
      },

      loadData() {
        this.loading = true
        return apiQuery('private', 'data-get-record', {
          table: window.x2.tables.pak,
          recordId: this.id
        }, false).then(pak => {
          if (pak.HLS_LINK)
           pak.HLS_LINK = pak.HLS_LINK.replace('http://10.11.12.28:9999', '/video')
          return apiQuery('private', 'data-get-record', {
            table: pak.USAGE === '0'  ? window.x2.tables.rooms : window.x2.tables.egerooms,
            recordId: pak.SYS_GUIDFK.value
          }, false).then(room => {
            pak['CLASSROOM'] = room.CLASSROOM
            return apiQuery('private', 'data-get-record', {
              table: window.x2.tables.schools,
              recordId: room.SYS_GUIDFK.value
            }, false).then(school => {
              pak['ORG'] = school.TYPE_OBJECT
              pak['ADDRESS'] = school.ADDRESS
              pak['CODE'] = school.CODE_PPE_EGE
              this.stream = pak
              this.loading = false
            })
          }).catch(() => {
            this.stream = pak
            this.loading = false
          })

        })
      }
    }
  }
</script>

<style>
  div.player-error-screen__code[data-error-screen] {
    display: none;
  }
</style>
